import React, { Component } from "react";
import PropTypes from "prop-types";

class TooltipInputField extends Component {
	constructor(props) {
		super(props);

		this.state = {
			displayTooltip: props.opened
		};
	}

	hideTooltip = () => {
		if (!this.props.opened) {
			this.setState({ displayTooltip: false });
		}
	};
	showTooltip = () => {
		if (!this.props.opened) {
			this.setState({ displayTooltip: true });
		}
	};

	componentDidUpdate(prevProps) {
		if (prevProps.opened !== this.props.opened) {
			this.setState({ displayTooltip: this.props.opened });
		}
	}

	render() {
		let { message, position } = this.props;
		return (
			<span
				className={`dfa-tooltip dfa-tooltip-position-${position}`}
				onMouseLeave={this.hideTooltip}
			>
				{this.state.displayTooltip && (
					<div className={`dfa-tooltip-bubble dfa-tooltip-${position}`}>
						<div className="dfa-tooltip-message">{message}</div>
					</div>
				)}
				<span
					className="dfa-tooltip-trigger"
					onMouseOver={this.showTooltip}
					onFocus={this.showTooltip}
				>
					{this.props.children}
				</span>
			</span>
		);
	}
}

TooltipInputField.propTypes = {
	message: PropTypes.oneOfType([PropTypes.string, PropTypes.object]).isRequired,
	position: PropTypes.string.isRequired
};

export default TooltipInputField;
